module.exports = __webpack_public_path__ + "img/max-envelope-check.9e7c23e2.svg";